﻿import { CategoryScale, Chart, ChartDataset, Legend, LineController, LineElement, LinearScale, PointElement, TimeScale, Title, Tooltip } from 'chart.js';

Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, TimeScale, Tooltip, Legend);

function hentAllDataTilGraf(grafDataElement: Element): GrafDataModel {
    const json = grafDataElement.getAttribute('data-json')!;
    return JSON.parse(json);
}

enum NorskGrafType {
    Linje = "Linje",
    Radar = "Radar",
    Stolpe = "Stolpe",
}

function norskGrafTypeToGraphType(grafType: NorskGrafType) {
    switch (grafType) {
        case NorskGrafType.Linje:
            return "line";
        case NorskGrafType.Radar:
            return "radar";
        case NorskGrafType.Stolpe:
            return "bar";
        default:
            return "line";
    }
}

function hentDatasett(ledetekst: string, datasett: number[], farge: string): ChartDataset {
    return {
        label: ledetekst,
        data: datasett,
        borderColor: farge,
        backgroundColor: farge,
        pointBackgroundColor: farge,
        borderWidth: 2,
        fill: false,
    };
}

const pointStyles: Chart.PointStyle[] = ['circle', 'rect', 'triangle', 'rectRot']
const grafer: NodeListOf<HTMLElement> = document.querySelectorAll('.js-graf-data');

for (let i = 0; i < grafer.length; i++) {
    const canvasId = grafer[i].dataset.id!;
    const ctx = document.getElementById(canvasId) as HTMLCanvasElement;

    const data: GrafDataModel = hentAllDataTilGraf(grafer[i]);
    const datasett1: number[] = data.Datasett1_parsed.map(d => parseFloat(d)).filter(d => !Number.isNaN(d));
    const datasett2: number[] = data.Datasett2_parsed.map(d => parseFloat(d)).filter(d => !Number.isNaN(d));
    const datasett3: number[] = data.Datasett3_parsed.map(d => parseFloat(d)).filter(d => !Number.isNaN(d));
    const datasett4: number[] = data.Datasett4_parsed.map(d => parseFloat(d)).filter(d => !Number.isNaN(d));
    const datasett5: number[] = data.Datasett5_parsed.map(d => parseFloat(d)).filter(d => !Number.isNaN(d));
    const datasett6: number[] = data.Datasett6_parsed.map(d => parseFloat(d)).filter(d => !Number.isNaN(d));

    const datasets: ChartDataset[] = [];

    if (datasett1.length > 0) {
        datasets.push(hentDatasett(data.Datasett1_Ledetekst, datasett1, '#410464'));
    }

    if (datasett2.length > 0) {
        datasets.push(hentDatasett(data.Datasett2_Ledetekst, datasett2, '#09756b'));
    }

    if (datasett3.length > 0) {
        datasets.push(hentDatasett(data.Datasett3_Ledetekst, datasett3, '#5e18d5'));
    }

    if (datasett4.length > 0) {
        datasets.push(hentDatasett(data.Datasett4_Ledetekst, datasett4, '#e31c2d'));
    }

    if (datasett5.length > 0) {
        datasets.push(hentDatasett(data.Datasett5_Ledetekst, datasett5, '#383838'));
    }

    if (datasett6.length > 0) {
        datasets.push(hentDatasett(data.Datasett6_Ledetekst, datasett6, '#ffee45'));
    }

    new Chart(ctx, {
        type: norskGrafTypeToGraphType(data.GrafType),
        data: {
            labels: data.Xakse,
            datasets: datasets.map((dataset, index) => ({ ...dataset, pointStyle: pointStyles[index] })),
        },
        options: {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        font: {
                            family: "'Rubik', sans-serif"
                        }
                    },
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                },
            },
            responsive: true,
            hover: {
                mode: 'index',
                intersect: false,
            },
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        callback: function (value, index, values) {
                            return value + data.Benevnelse_Yakse;
                        },
                    },
                },
            },
        },
    });
}

interface GrafDataModel {
    Datasett1_Ledetekst: string;
    Datasett1_parsed: string[];
    Datasett1: string;
    Datasett2_Ledetekst: string;
    Datasett2_parsed: string[];
    Datasett2: string;
    Datasett3_Ledetekst: string;
    Datasett3_parsed: string[];
    Datasett3: string;
    Datasett4_Ledetekst: string;
    Datasett4_parsed: string[];
    Datasett4: string;
    Datasett5_Ledetekst: string;
    Datasett5_parsed: string[];
    Datasett5: string;
    Datasett6_Ledetekst: string;
    Datasett6_parsed: string[];
    Datasett6: string;
    GrafType: NorskGrafType;
    Ledetekster_Xakse: string;
    Xakse: string[];
    Benevnelse_Yakse: string;
}
